module.exports = __webpack_public_path__ + "static/media/icon-symptoms-dry-cough.630fe3eb.svg";